import React from 'react';

import PropTypes from 'prop-types';
import cn from 'classnames';

import { formatCurrency } from 'modules/common/utils';
import Discounts from 'modules/branch/services-management/services/components/discounts/Discounts';

import { useGetDiscount, useGetSettings } from '../../services/hooks';

function ReceiptsV2({
  subtotal,
  withDiscount,
  withHrLast,
  isDark,
  setTotal,
  isSmall,
}) {
  const [, , discountIncluded] = useGetDiscount();
  const { chargesList, totalVAT, totalCharge } = useGetSettings();

  const discountValue = discountIncluded?.discountValue(subtotal || 0);
  const discountedSubTotal = discountIncluded?.discountedSubTotal(
    subtotal || 0
  );

  const VAT = +(discountedSubTotal + totalCharge) * (totalVAT / 100);
  const getTotal = discountedSubTotal + totalCharge + VAT;

  React.useEffect(() => {
    setTotal(getTotal);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [JSON.stringify(getTotal), setTotal]);

  return (
    <div className="space-y-3">
      <hr
        className={cn('border-dashed', {
          'border-gray-700': isDark,
        })}
      />

      <div
        className={cn('space-y-1 py-0', {
          'text-xs': isSmall,
          'text-sm': !isSmall,
        })}
      >
        <div className="flex items-center justify-between">
          <div>Subtotal</div>
          <div>{formatCurrency(subtotal || 0)}</div>
        </div>
        <div className="flex items-center justify-between">
          <div>Discount</div>
          <div>
            -{' '}
            {discountIncluded?.hasSelectedDiscount
              ? formatCurrency(discountValue || 0)
              : formatCurrency(0)}
          </div>
        </div>
      </div>

      <hr
        className={cn('border-dashed', {
          'border-gray-700': isDark,
        })}
      />

      <div
        className={cn('space-y-1 py-0', {
          'text-xs': isSmall,
          'text-sm': !isSmall,
        })}
      >
        {chargesList?.map((item, key) => {
          const k = key;

          return (
            <div className="flex items-center justify-between" key={k}>
              <div>{item?.name}</div>
              <div>{formatCurrency(item?.value || 0) || '-'}</div>
            </div>
          );
        })}

        <div className="flex items-center justify-between">
          <div>VAT ({totalVAT}%)</div>
          <div>{formatCurrency(VAT || 0) || '-'}</div>
        </div>
      </div>

      <hr
        className={cn('border-dashed', {
          'border-gray-700': isDark,
        })}
      />

      <div
        className={cn('space-y-1 py-0', {
          'text-xs': isSmall,
          'text-sm': !isSmall,
        })}
      >
        <div className="flex items-center justify-between">
          <div className="flex-1 text-right pr-5">Total</div>
          <div className="font-bold">{formatCurrency(getTotal || 0)}</div>
        </div>
      </div>

      {withDiscount && <Discounts disabledButton={false} isAlertModal />}

      {withHrLast && (
        <hr
          className={cn('border-dashed', {
            'border-gray-700': isDark,
          })}
        />
      )}
    </div>
  );
}

export default ReceiptsV2;

ReceiptsV2.defaultProps = {
  subtotal: 0,
  withDiscount: false,
  isDark: false,
  withHrLast: true,
  isSmall: false,
  setTotal: () => {},
};

ReceiptsV2.propTypes = {
  subtotal: PropTypes.number,
  withDiscount: PropTypes.bool,
  isSmall: PropTypes.bool,
  isDark: PropTypes.bool,
  withHrLast: PropTypes.bool,
  setTotal: PropTypes.instanceOf(Function),
};
